<template>
  <div class="px-4 mt-8 mx-auto bg-white rounded-lg max-w-[50vw] w-[vw]">
    <div class=" p-5 text-center">
      <h1 class="uppercase font-bold text-[24px]">Создание ЛИДа</h1>
    </div>
  </div>
  <div class="mt-10 bg-white p-4 rounded-[4px] max-w-[50vw] w-[vw] ml-auto mr-auto ">
    <h2 class=" pl-5 text-[24px] font-bold">Контактное лицо</h2>
    <div class="flex p-5  ">
      <div class="flex flex-col w-full">
        <p class="text-gray-400 uppercase">Имя:</p>
        <input
          type="text"
          placeholder="Введите Имя"
          class="bg-slate-50 h-9 px-3 py-2 w-full v-bgray rounded-sm text-sm text-teal-700"
          v-model="contact_name"
        />
      </div>
    </div>

    <div class="flex p-5  ">
      <div class="flex flex-col w-full">
        <p class="text-gray-400 uppercase">Телефон:</p>
        <input
          type="text"
          placeholder="+7 (___) ___-__-__"
          class="bg-slate-50 h-9 px-3 py-2 w-full v-bgray rounded-sm text-sm text-teal-700"
          v-model="contact_phone"
          @focus="handlePhoneFocus"
          @blur="handlePhoneBlur"
          @input="formatPhoneNumber('contact_phone')"
          @keydown="handlePhoneKeyDown"
          maxlength="18"
        />
      </div>
    </div>
    
    <div class="flex p-5 ">
      <div class="flex flex-col w-full">
        <p class="text-gray-400 uppercase">Должность:</p>
        <select v-model="contact_role" class="bg-slate-50 h-9 px-3 py-2 w-full v-bgray rounded-sm text-sm text-teal-700" :class="contact_role == '' ? 'text-gray-400' : undefined">
          <option disabled value="">Выберите должность</option>
          <option value="1">ответственный за тахограф</option>
          <option value="2">ответственный за мониторинг</option>
          <option value="3">ответственный за пропуск</option>
          <option value="4">ответственный за транспорт (все)</option>
          <option value="5">ответственный за карты</option>
          <option value="6">бухгалтерия</option>
        </select>
      </div>
    </div>
    <h2 class="text-[24px] font-bold pl-5 ">Клиент</h2>
    <div class="flex p-5  ">
      <div class="flex flex-col w-full">
        <p class="text-gray-400 uppercase">Наименование:</p>
        <input
          type="text"
          placeholder="Введите Наименование"
          class="bg-slate-50 h-9 px-3 py-2 w-full v-bgray rounded-sm text-sm text-teal-700"
          v-model="client_name"
        />
      </div>
    </div>
    <div class="flex p-5 ">
      <div class="flex flex-col w-full">
        <p class="text-gray-400 uppercase">Телефон:</p>
        <input
          type="text"
          placeholder="+7 (___) ___-__-__"
          class="bg-slate-50 h-9 px-3 py-2 w-full v-bgray rounded-sm text-sm text-teal-700"
          v-model="client_phone"
          @focus="handlePhoneFocus"
          @blur="handlePhoneBlur"
          @input="formatPhoneNumber('client_phone')"
          @keydown="handlePhoneKeyDown"
          maxlength="18"
        />
      </div>
    </div>
    <div class="flex flex-col justify-center">
      <h3 class="text-[20px] font-bold lato-bold text-center">
        Комментарий к ЛИДу
      </h3>
      <div class="px-5">
        <textarea class="w-full px-5 py-2 bg-white v-bgray rounded-md text-sm" type="text" name="comment" v-model="comment"></textarea>
        
        <div class="flex justify-end  mt-2">
          <div class="flex mt-4 w-full overflow-y-auto">
            <a v-for="i in preloadedImages"
                :key="i"
                class="flex flex-col mr-4 text-center"
                :href="imagePrefix + 'comment/orig/' + i.img"
                target="_blank"
            >
              <span class="w-16 h-16 rounded-md overflow-hidden mb-1">
                <img
                  v-if="i.img.includes('png') || i.img.includes('jpg') 
                      || i.img.includes('jpeg') || i.img.includes('bmp')"
                  class="w-full h-full object-cover"
                  :src="imagePrefix + 'comment/mini/' + i.img"
                  alt=""
                />
                <img
                  v-else-if="i.img.includes('pdf')"
                  class="w-full h-full object-cover"
                  src="https://api.tahocrm.ru/images/pdf-file.png"
                  alt=""
                />
                <img
                  v-else
                  class="w-full h-full object-cover"
                  src="https://api.tahocrm.ru/images/txt-file.png"
                  alt=""
                />
              </span>
            </a>
          </div>
          <UploadImg :item="{}" :id="id" type="comment" :status="100" name="Прикрепить картинки" @upload="uploaded($event)"/>
          <button
            class="v-btn v-btn--sm v-btn--sm bg-green-500 hover:bg-green-400 ml-4 h-[40px]"
            @click="sendComment()"
          >
            <span class="v-btn_text flex items-center">
              <svg class="fill-white w-16px h-16px mr-3">
                <use xlink:href="@/assets/i.svg#ico-telegram"></use>
              </svg>
              <span class="lato-bold">ОТПРАВИТЬ</span>
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import API from "@/services/api";
import UploadImg from "@/components/ui/UploadImg.vue";

export default {
  name: "CreateLead",

  components: {
    UploadImg
  },

  data() {
    return {
      moment: moment,
      contact_name: "",
      contact_phone: "",
      contact_role: "",
      client_name: "",
      client_phone: "",
      comment: "",
      preloadedImages: [],
      imagePrefix: API.IMG,

    }
  },

  computed: {
    ...mapGetters([]),
  },

  methods: {
    ...mapActions([
      "throwAlert"
    ]),
    
    uploaded(data) {
      let picture = data?.data?.picture ?? [];
      this.preloadedImages.push(...picture);
    },

    handlePhoneFocus(event) {
      if (!event.target.value) {
        event.target.value = '+7 (';
      }
    },

    handlePhoneBlur(event) {
      if (event.target.value === '+7 (') {
        event.target.value = '';
      }
    },

    handlePhoneKeyDown(event) {
      // Разрешаем: backspace, delete, tab, escape, enter, стрелки
      if ([46, 8, 9, 27, 13, 110].indexOf(event.keyCode) !== -1 || 
          (event.keyCode >= 35 && event.keyCode <= 39)) {
        return;
      }
      
      // Разрешаем только цифры
      if ((event.keyCode < 48 || event.keyCode > 57) && (event.keyCode < 96 || event.keyCode > 105)) {
        event.preventDefault();
      }
    },

    formatPhoneNumber(field) {
      let phone = this[field].replace(/\D/g, '');
      if (phone.length > 0) {
        if (phone.length < 1) {
          phone = '+7 (' + phone;
        } else if (phone.length < 4) {
          phone = '+7 (' + phone.substring(1);
        } else if (phone.length < 7) {
          phone = '+7 (' + phone.substring(1, 4) + ') ' + phone.substring(4);
        } else if (phone.length < 9) {
          phone = '+7 (' + phone.substring(1, 4) + ') ' + phone.substring(4, 7) + '-' + phone.substring(7);
        } else {
          phone = '+7 (' + phone.substring(1, 4) + ') ' + phone.substring(4, 7) + '-' + phone.substring(7, 9) + '-' + phone.substring(9, 11);
        }
      }
      this[field] = phone;
    },

    async sendComment() {
      if (
        this.contact_name == "" ||
        this.contact_phone == "" ||
        this.contact_role == "" ||
        this.client_name == "" ||
        this.client_phone == "" ||
        this.comment == ""
      ) {
        let fields = []
        this.contact_name == "" ? fields.push('Имя контактного лица'): undefined 
        this.contact_phone == "" ? fields.push('Телефон контактного лица'): undefined 
        this.contact_role == "" ? fields.push('Должность контактного лица'): undefined 
        this.client_name == "" ? fields.push('Наименование клиента'): undefined 
        this.client_phone == "" ? fields.push('Телефон клиента'): undefined 
        this.comment == "" ? fields.push('Комментарий'): undefined 
        alert('Пожалуйста, заполните все поля!'+ `(${fields.join(', ')})`)
      } else {
        const formData = new FormData()

        formData.append('contact_name', this.contact_name)
        formData.append('contact_phone', this.contact_phone.replace(/\D/g, ''))
        formData.append('contact_role', this.contact_role)
        formData.append('client_name', this.client_name)
        formData.append('client_phone', this.client_phone.replace(/\D/g, ''))
        formData.append('comment', this.comment)
        formData.append("img", this.preloadedImages.map(({id}) => id).join(' '));

        await API.POST('lead/agent-lead', formData).then((res) => {
          res.data.alert ? this.throwAlert(res.data.alert) : undefined
        })

        this.contact_name = "" 
        this.contact_phone = ""
        this.contact_role = ""
        this.client_name = ""
        this.client_phone = ""
        this.comment = ""
        this.preloadedImages = []
      }
    },
  }
}
</script>

<style>
.bg-status-8 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 72 126 / var(--tw-bg-opacity));
}
</style>

<style scoped>
.grid-cols-15 {
  grid-template-columns: 70px repeat(11, minmax(0, 1fr)) !important;
}
.no-select {
  -webkit-user-select: none; /* Chrome/Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE/Edge */
  user-select: none; /* Стандартный синтаксис */
}
</style>